// Memberships
export const nordAdmins = ['System-Admin', 'Application-Admin']
export const sysAdmin = ['System-Admin']

// Roles
export const partnerAccessAdmin = ['PartnerAccessAdmin']
export const partnerAccessAll = ['PartnerAccessAdmin', 'PartnerAccessUser']
